import type { ChartsBlock } from "@mw/shared/payload-types";
import { Block } from "./Block";
import { cn } from "@ui/lib/utils";
import { CornerMarkerDot } from "@ui/components/core/CornerMarkerDot";
import { BarChart, type BarChartConfig } from "./BarChart";
import { ChartVideo, type VideoConfig } from "./ChartVideo";

type ChartOrVideoConfig = BarChartConfig | VideoConfig;

const ChartBlockContent = ({ config }: { config: ChartOrVideoConfig }) => {
  if (config.type === "video") {
    return <ChartVideo video={config as VideoConfig} />;
  }
  return <BarChart chart={config as BarChartConfig} />;
};

export const BlockCharts = (props: ChartsBlock) => {
  const { layout = "grid", charts = [] } = props;

  // This block requires exactly 2 charts
  if (!charts || charts.length !== 2) {
    return null;
  }

  return (
    <Block name='charts'>
      <div className='container'>
        <div className={cn(layout === "grid" && "grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]")}>
          {/* First chart or video */}
          <ChartBlockContent config={charts[0] as ChartOrVideoConfig} />

          {/* Separator - horizontal on mobile, vertical on desktop */}
          <div className='relative h-1 w-full bg-overlay-dark md:h-auto md:w-1'>
            {/* Mobile markers - left and right */}
            <div className='md:hidden'>
              <CornerMarkerDot backgroundColor='white' position='bottomLeft' />
              <CornerMarkerDot backgroundColor='white' position='bottomRight' />
            </div>
            {/* Desktop markers - top and bottom center */}
            <div className='hidden md:block'>
              <CornerMarkerDot backgroundColor='white' position='topCentered' />
              <CornerMarkerDot backgroundColor='white' position='bottomCentered' />
            </div>
          </div>

          {/* Second chart or video */}
          <ChartBlockContent config={charts[1] as ChartOrVideoConfig} />
        </div>
      </div>
    </Block>
  );
};
